import { toast } from 'react-toastify'

const BLOCKED_EMAIL_PREFIXES = [
  'pmm4654',
  // 'zach.burklund',
  'browsertest',
  'dhampel',
  'qackerman',
  'zburklund',
  // 'tnishimoto',
]

const shouldSendToZapier = (user) => {
  if (process.env.TEST_ZAPIER) return true
  // adjust locally
  if (window.location.origin.startsWith('http://localhost')) return false
  if (window.location.origin.startsWith('https://dev.goparco')) return false
  if (window.location.origin.startsWith('https://beta.goparco')) return false

  if (
    BLOCKED_EMAIL_PREFIXES.find((blockedPrefix) =>
      user?.email?.startsWith(blockedPrefix)
    )
  )
    return false
  if (process.env.NODE_ENV === 'test') return false

  return true
}

export const callZapier = async ({
  hookUrl,
  user,
  payload = {},
  sendNotification = false,
  notificationMessage,
}) => {
  // console.log(payload)
  if (!shouldSendToZapier(user)) return

  if (sendNotification) {
    toast.info(notificationMessage, {
      position: 'top-center',
      autoClose: 5000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    })
  }

  await fetch(hookUrl, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}
